import { render, staticRenderFns } from "./LayerLegend.vue.js?vue&type=template&id=71a9f634&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerLegend.vue?vue&type=template&id=71a9f634&scoped=true"
import script from "./LayerLegend.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerLegend.vue?vue&type=script&lang=js"
export * from "./LayerLegend.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerLegend.vue?vue&type=script&lang=js"
import style0 from "./LayerLegend.vue.scss?vue&type=style&index=0&id=71a9f634&prod&scoped=true&lang=scss!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerLegend.vue?vue&type=style&index=0&id=71a9f634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9f634",
  null
  
)

export default component.exports